module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/sidebar/en-50184acb755f56ed34a3d33a6d16f2fe.jpg";